
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TeamCarousel = ({ content }) => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const items = content.items.map((item) => (
        <div key={item.user} className='flex flex-col items-center text-center mt-10 slick-slide-content'>
            <img className='w-80 smd:w-96 slg:w-[600px] xl:w-[800px] mx-auto' src={item.img} alt='team' />
            <span className='font-poppins font-medium mt-5 xl:text-xl'>{item.user}</span>
            <p className='font-biryani text-center mr-5 ml-5 text-[#808080] text-sm mt-5 mb-5 xl:text-lg'>{item.text}</p>
        </div>
    ));

    return (
        <div id='carousel'>
            <Slider {...settings}>{items}</Slider>
        </div>
    );
};

export default TeamCarousel;
